import { Injectable } from '@angular/core';
import { IccGlassTypeVariant } from '@icc/window-door/types';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FillingsListPageStoreService {
    private selectedGlassTypeVariant$ = new BehaviorSubject<IccGlassTypeVariant | null>(null);

    setSelectedGlassTypeVariant$(value: IccGlassTypeVariant | null) {
        this.selectedGlassTypeVariant$.next(value);
    }

    get selectedGlassTypeVariant() {
        return this.selectedGlassTypeVariant$.getValue();
    }
}
